export default __webpack_public_path__ + "static/fall1 (7)-e7d1555680292db39c9b0f20a2a4221d.jpeg";